import dayjs from "dayjs"

export const ruralUrbanLabel={
    rural:'Rural',
    urban:'Urban'
}

export const ruralUrban={
    rural:'rural',
    urban:'Urban'
}

export const facilityApprovalFormData = {
  hfr_id: {
    '#type': 'verify',
    '#title': 'HFR ID',
    '#isDisabled':false,
    '#webform_key': 'hfr_id',
    '#required': true,
  },
  facility_category: {
    '#type': 'select',
    '#title': 'Facility Category',
    '#webform_key': 'facility_category',
    '#required': false,
    '#multiDropdown':true,
    '#isDisabled':false,
    '#options': {
      // HFN1: 'Delivery Point',
      // HFN2: 'NRC',
      // HFN3: 'NUHM Funded (only for Urban PHC)',
    },
  },
  facility_name: {
    '#type': 'textfield',
    '#title': 'Health Facility Name',
    '#webform_key': 'facility_name',
    '#required': true,
    '#isDisabled':true,
  },
  facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'facility_type',
    '#isDisabled':true,
    '#required': false,
    '#options': {
      HFN1: 'PHC',
      HFN2: 'District Hospital',
      HFN3: 'Railway Hospital',
    },
  },
  ownership: {
    '#type': 'select',
    '#title': 'Ownership',
    '#webform_key': 'ownership',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Ownership1',
      HFN2: 'Ownership2',
      HFN3: 'Ownership3',
    },
  },
  administrative_body: {
    '#type': 'select',
    '#title': 'Administrative Body',
    '#webform_key': 'administrative_body',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Admin1',
      HFN2: 'Admin2',
      HFN3: 'Admin3',
    },
  },
  central_govt_dept: {
    '#type': 'select',
    '#title': 'Central Government Dept',
    '#webform_key': 'central_govt_dept',
    '#isDisabled':true,
    '#required': false,
    '#options': {
      HFN1: 'HFN1',
      HFN2: 'HFN2',
      HFN3: 'HFN3',
    },
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
    '#isDisabled':false,
    '#required': true,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
}

export const facilityApprovalFormState = {
    hfr_id: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        verifiedDetails: ''
    },
    facility_category: {
        isError: false,
        message: '',
        isDisable: false,
        value: [],
        id: [],
        code: []
    },
    facility_name: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
    },
    facility_type: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: ''
    },
    ownership: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: ''
    },
    administrative_body: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: ''
    },
    central_govt_dept: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: ''
    },
    rural_urban: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
}

export const enrollmentApprovalDetailsFormState = {
    date_of_enrollment: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    effective_from_date: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    status: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: ''
    },
    sanctionedbed_count: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    functionalbed_count: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    }
}

export const hierarchyApprovalDetailsRuralFormState = {
    state: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id: '',
        code: undefined
    },
    district: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id: '',
        code: undefined
    },
    sub_district: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    block: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    health_block: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    sub_division: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    village: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    gram_panchayat: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    parlimentary: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    lac: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
}

export const hierarchyApprovalDetailsUrbanFormState = {
    state: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id: '',
        code: undefined
    },
    district: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id: '',
        code: undefined
    },
    ulb: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    sub_district: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    health_block: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    sub_division: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    ward: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    parlimentary: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
    lac: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id: '',
        code: undefined
    },
}

export const locationApprovalDetailsFormState = {
    pincode: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    lattitude: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    longitude: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    address: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
}

export const initialUpdateHealthFacilityFormState = (healthFacilityData: any, locationData: any, category_code: null, category_name: any, category_id: any) => {
    return {
        facility_name: {
            value: healthFacilityData?.facility_name,
            isError: false,
            message: ''
        },
        hfr_id: {
            value: healthFacilityData?.hfr_id,
            isError: false,
            message: ''
        },
        facility_type: {
            value: healthFacilityData?.facility_type_name,
            id: healthFacilityData?.facility_type_id,
            isError: false,
            message: ''
        },
        ownership: {
            value: healthFacilityData?.ownership_name,
            id: healthFacilityData?.ownership_id,
            isError: false,
            message: ''
        },
        administrative_body: {
            value: healthFacilityData?.admin_body_name,
            id: healthFacilityData?.admin_body_id,
            isError: false,
            message: ''
        },
        central_govt_dept: {
            value: healthFacilityData?.central_govt_dept_name,
            id: healthFacilityData?.central_govt_dept_id,
            isError: false,
            message: ''
        },
        rural_urban: {
            value: locationData?.urban_rual?.urban_rural_name === 'rural' ? 'Rural' : 'Urban',
            id: locationData?.urban_rual?.urban_rual_id,
            isError: false,
            message: ''
        },
        facility_category: {
            value: category_name,
            id: category_id,
            code: category_code,
            isError: false,
            message: ''
        }
    }

}

export const initialUpdateEnrollmentDetailsFormState = (healthFacilityData: any,effectiveFromDate:any) => {
    return {
        date_of_enrollment: {
            value: dayjs(healthFacilityData?.enrollment_dt).format('YYYY-MM-DD'),
            isError: false,
            message: '',
        },
        effective_from_date: {
            value: dayjs(effectiveFromDate).format('YYYY-MM-DD'),
            isError: false,
            message: '',
        },
        sanctionedbed_count: {
            value: healthFacilityData?.sanctioned_bed_count,
            isError: false,
            message: '',
        },
        functionalbed_count: {
            value: healthFacilityData?.functional_bed_count,
            isError: false,
            message: '',
        },
        status: {
            value: healthFacilityData?.status_name,
            id: healthFacilityData?.status_id,
            isError: false,
            message: '',
        },
    }
}

export const initialUpdateHierarchyRuralFormState = (locationData: any) => {
    return {
        state: {
            value: `${locationData?.state?.state_name}-${locationData?.state?.state_code}`,
            id: locationData?.state?.state_id,
            code: locationData?.state?.state_code,
            isError: false,
            message: '',
        },
        district: {
            value: `${locationData?.district?.district_name}-${locationData?.district?.district_code}`,
            id: locationData?.district?.district_id,
            code: locationData?.district?.district_code,
            isError: false,
            message: '',
        },
        sub_district: {
            value: locationData?.sub_district?.sub_district_name ? `${locationData?.sub_district?.sub_district_name}-${locationData?.sub_district?.sub_district_code}` : '',
            id: locationData?.sub_district?.sub_district_id,
            code: locationData?.sub_district?.sub_district_code,
            isError: false,
            message: '',
        },
        block: {
            value: locationData?.block?.block_name ? `${locationData?.block?.block_name}-${locationData?.block?.block_code}` : '',
            id: locationData?.block?.block_id,
            code: locationData?.block?.block_code,
            isError: false,
            message: '',
        },
        health_block: {
            value: locationData?.health_block?.health_block_name ? `${locationData?.health_block?.health_block_name}-${locationData?.health_block?.health_block_code}` : '',
            id: locationData?.health_block?.health_block_id,
            code: locationData?.health_block?.health_block_code,
            isError: false,
            message: '',
        },
        sub_division: {
            value: locationData?.sub_division?.sub_division_name ? `${locationData?.sub_division?.sub_division_name}-${locationData?.sub_division?.sub_division_name?.sub_division_code}` : '',
            id: locationData?.sub_division?.sub_division_id,
            code: locationData?.sub_division?.sub_division_code,
            isError: false,
            message: '',
        },
        village: {
            value: locationData?.village?.village_name ? `${locationData?.village?.village_name}-${locationData?.village?.village_code}` : '',
            id: locationData?.village?.village_id,
            code: locationData?.village?.village_code,
            isError: false,
            message: '',
        },
        gram_panchayat: {
            value: locationData?.gram_panchayat_name ? `${locationData?.gram_panchayat_name}-${locationData?.gram_panchayat_code}` : '',
            id: locationData?.gram_panchayat_id ? locationData?.gram_panchayat_id : '',
            code: locationData?.gram_panchayat_code ? locationData?.gram_panchayat_code : '',
            isError: false,
            message: '',
        },
        parlimentary: {
            value: locationData?.urba_rural_name?.toLowerCase() === 'rural' && locationData?.pc?.pc_name ? locationData?.pc?.pc_name : '',
            id: locationData?.pc?.pc_id,
            code: locationData?.pc?.pc_code,
            isError: false,
            message: '',
        },
        lac: {
            value: locationData?.urba_rural_name?.toLowerCase() === 'rural' && locationData?.lac?.lac_name ? locationData?.lac?.lac_name : '',
            id: locationData?.lac?.lac_id,
            code: locationData?.lac?.lac_code,
            isError: false,
            message: '',
        },
    }
}

export const initialUpdateHierarchyUrbanFormState = (locationData: any) => {
    return {
        state: {
            value: `${locationData?.state?.state_name}-${locationData?.state?.state_code}`,
            id: locationData?.state?.state_id,
            code: locationData?.state?.state_code,
            isError: false,
            message: '',
        },
        district: {
            value: `${locationData?.district?.district_name}-${locationData?.district?.district_code}`,
            id: locationData?.district?.district_id,
            code: locationData?.district?.district_code,
            isError: false,
            message: '',
        },
        sub_district: {
            value: locationData?.sub_district?.sub_district_name ? `${locationData?.sub_district?.sub_district_name}-${locationData?.sub_district?.sub_district_code}` : '',
            id: locationData?.sub_district?.sub_district_id,
            code: locationData?.sub_district?.sub_district_code,
            isError: false,
            message: '',
        },
        ulb: {
            value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === 'urban' && locationData?.ulb?.ulb_name ? `${locationData?.ulb?.ulb_name}-${locationData?.ulb?.ulb_code}` : '',
            id: locationData?.ulb?.ulb_id,
            code: locationData?.ulb?.ulb_code,
            isError: false,
            message: '',
        },
        health_block: {
            value: locationData?.health_block?.health_block_name ? `${locationData?.health_block?.health_block_name}-${locationData?.health_block?.health_block_code}` : '',
            id: locationData?.health_block?.health_block_id,
            code: locationData?.health_block?.health_block_code,
            isError: false,
            message: '',
        },
        sub_division: {
            value: locationData?.sub_division?.sub_division_name ? `${locationData?.sub_division?.sub_division_name}-${locationData?.sub_division?.sub_division_code}` : '',
            id: locationData?.sub_division?.sub_division_id,
            code: locationData?.sub_division?.sub_division_code,
            isError: false,
            message: '',
        },
        ward: {
            value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === 'urban' && locationData?.ward?.ward_name ? `${locationData?.ulb?.ulb_name}-${locationData?.ulb?.ulb_code} - ${locationData?.ward?.ward_name}-${locationData?.ward?.ward_code}` : '',
            id: locationData?.ward?.ward_id,
            code: locationData?.ward?.ward_code,
            isError: false,
            message: '',
        },
        parlimentary: {
            value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === 'urban' && locationData?.pc?.pc_name ? locationData?.pc?.pc_name : '',
            id: locationData?.pc?.pc_id,
            code: locationData?.pc?.pc_code,
            isError: false,
            message: '',
        },
        lac: {
            value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === 'urban' && locationData?.lac?.lac_name ? locationData?.lac?.lac_name : '',
            id: locationData?.lac?.lac_id,
            code: locationData?.lac?.lac_code,
            isError: false,
            message: '',
        }
    }
}

export const initialUpdateLocationApprovalDetailsFormState = (healthFacilityData: any) => {
    return {
        pincode: {
            value: healthFacilityData?.pincode,
            isError: false,
            message: '',
        },

        lattitude: {
            value: healthFacilityData?.latitude,
            isError: false,
            message: '',
        },
        longitude: {
            value: healthFacilityData?.longitude,
            isError: false,
            message: '',
        },
        address: {
            value: healthFacilityData?.address,
            isError: false,
            message: '',
        },
    }
}

export const updateHierarchyDetailsRuralFormState = (HierarchyDetailsRuralFormState: any) => {
    return {
        sub_district: {
            ...HierarchyDetailsRuralFormState.sub_district,
            value: '',
            id: '',
        },
        health_block: {
            ...HierarchyDetailsRuralFormState.health_block,
            value: '',
            id: '',
        },
        sub_division: {
            ...HierarchyDetailsRuralFormState.health_block,
            value: '',
            id: '',
        },
        block: {
            ...HierarchyDetailsRuralFormState.block,
            value: '',
            id: '',
        },
        village: {
            ...HierarchyDetailsRuralFormState.village,
            value: '',
            id: '',
            code: ''
        },
        gram_panchayat: {
            ...HierarchyDetailsRuralFormState.gram_panchayat,
            value: '',
            id: '',
            code: ''
        },
    }
}

export const updateHierarchyDetailsUrbanFormState = (HierarchyDetailsRuralFormState: any) => {
    return {
        sub_district: {
            ...HierarchyDetailsRuralFormState.sub_district,
            value: '',
            id: '',
        },
        health_block: {
            ...HierarchyDetailsRuralFormState.health_block,
            value: '',
            id: '',
        },
        sub_division: {
            ...HierarchyDetailsRuralFormState.health_block,
            value: '',
            id: '',
        }
    }
}

export const approvalSubmitPayload = (healthFacilityData: any, abdmData: any, isRural: boolean, hierarchyDetailsRuralFormState: any, hierarchyDetailsUrbanFormState: any, facilityDetailsFormState: any, enrollmentDetailsFormState: any, locationDetailsFormState: any, linkedVillageRural: any, linkedWardRural: any, linkedFacilitiesUrban: any, linkedFacilitiesRural: any, locationData: any, linkedGramPanchayatRural: any) => {
    return {
        facility_id: healthFacilityData?.facility_id || null,
        abdm_facility_name: abdmData?.abdm_facility_name || null,
        abdm_status: abdmData?.abdm_status || null,
        abdm_ownership: abdmData?.abdm_ownership || null,
        abdm_ownership_code: abdmData?.abdm_ownership_code || null,
        abdm_system_of_medicine_code: abdmData?.abdm_system_of_medicine_code || null,
        abdm_system_of_medicine: abdmData?.abdm_system_of_medicine || null,
        abdm_facility_type_code: abdmData?.abdm_facility_type_code || null,
        abdm_facility_type: abdmData?.abdm_facility_type || null,
        abdm_state_name: abdmData?.abdm_state_name || null,
        abdm_state_code: abdmData?.abdm_state_code || null,
        abdm_district_name: abdmData?.abdm_district_name || null,
        abdm_district_code: abdmData?.abdm_district_code || null,
        abdm_sub_district_name: abdmData?.abdm_sub_district_name || null,
        abdm_sub_district_code: abdmData?.abdm_sub_district_code || null,
        abdm_village_city_town_name: abdmData?.abdm_village_city_town_name || null,
        abdm_village_city_town_code: abdmData?.abdm_village_city_town_code || null,
        abdm_address: abdmData?.abdm_address || null,
        abdm_pincode: abdmData?.abdm_pincode || null,
        abdm_latitude: abdmData?.abdm_latitude || null,
        abdm_longitude: abdmData?.abdm_longitude || null,
        is_abdm_changes_required: abdmData?.is_abdm_changes_required || false,
        st_id: isRural ? (hierarchyDetailsRuralFormState.state.id || null) : (hierarchyDetailsUrbanFormState.state.id || null),
        dist_id: isRural ? (hierarchyDetailsRuralFormState.district.id || null) : (hierarchyDetailsUrbanFormState.district.id || null),
        sub_dist_id: isRural ? (hierarchyDetailsRuralFormState.sub_district?.id || null) : (hierarchyDetailsUrbanFormState.sub_district?.id || null),
        facility_name: facilityDetailsFormState.facility_name.value || null,
        enrollment_dt: enrollmentDetailsFormState.date_of_enrollment.value || null,
        urban_rual_id: facilityDetailsFormState.rural_urban.id || locationData?.urban_rual?.urban_rual_id || null,
        facility_type_id: facilityDetailsFormState.facility_type.id || null,
        ownership_id: facilityDetailsFormState.ownership.id || null,
        admin_body_id: facilityDetailsFormState.administrative_body.id || null,
        category_ids: Array.isArray(facilityDetailsFormState.facility_category.id) ? facilityDetailsFormState.facility_category.id : (facilityDetailsFormState.facility_category.id ? [facilityDetailsFormState.facility_category.id] : []),
        status_id: enrollmentDetailsFormState.status.id || null,
        sanctioned_bed_count: Number(enrollmentDetailsFormState.sanctionedbed_count.value) || 0,
        functional_bed_count: Number(enrollmentDetailsFormState.functionalbed_count.value) || 0,
        address: locationDetailsFormState.address.value || null,
        latitude: locationDetailsFormState.lattitude.value || null,
        longitude: locationDetailsFormState.longitude.value || null,
        pincode: locationDetailsFormState.pincode.value || null,
        effective_from_dt: enrollmentDetailsFormState.effective_from_date.value || null,
        village_ids: (linkedVillageRural || []).map((v: any) => v.village_id) || [],
        ward_ids: (linkedWardRural || []).map((w: any) => w.ward_id || w.ward?.ward_id) || [],
        linked_facility_ids: (isRural ? linkedFacilitiesRural : linkedFacilitiesUrban || []).map((f: any) => f.facility_id) || [],
        gram_panchayat_ids: (linkedGramPanchayatRural || []).map((g: any) => g.gram_panchayat_id) || [],
        hfr_id: facilityDetailsFormState.hfr_id.value || healthFacilityData?.hfr_id || null,
        ulb_id: hierarchyDetailsUrbanFormState.ulb.id || locationData?.ulb?.ulb_id || null,
        block_id: isRural ? (hierarchyDetailsRuralFormState?.block?.id || null): (hierarchyDetailsUrbanFormState?.block?.id || null),
        health_block_id: isRural ? (hierarchyDetailsRuralFormState?.health_block?.id || null) : (hierarchyDetailsUrbanFormState?.health_block?.id || null),
        sub_division_id: isRural ? (hierarchyDetailsRuralFormState?.sub_division?.id ||  null): (hierarchyDetailsUrbanFormState?.sub_division?.id || null),
        pc_id: isRural ? (hierarchyDetailsRuralFormState?.pc?.id  || null): (hierarchyDetailsUrbanFormState?.pc?.id || null),
        lac_id: isRural ? (hierarchyDetailsRuralFormState?.lac?.id || null): (hierarchyDetailsUrbanFormState?.lac?.id || null),
        ward_id: hierarchyDetailsUrbanFormState?.ward.id || locationData?.ward?.ward_id || null,
        village_id: isRural ? (hierarchyDetailsRuralFormState?.village?.id || null):(hierarchyDetailsUrbanFormState?.village?.id || null),
        gram_panchayat_id: isRural ? (hierarchyDetailsRuralFormState?.gram_panchayat?.id || null) : (hierarchyDetailsUrbanFormState?.gram_panchayat?.id || null),
        central_govt_dept_id: facilityDetailsFormState.central_govt_dept.id || null
    }
}

